'use client'

import type React from 'react'
import { createContext } from 'react'
import type { Actor } from 'xstate'

import { authMachine, authMachineCtx, startAppMachine } from '~/machines'
import { publicRuntimeConfig } from '~/utils'
import { AuthRouter } from './AuthRouter'
import { SessionProvider } from 'next-auth/react'

export type AuthActorContextType = {
  actor: Actor<typeof authMachine>
}

export const AuthActorContext = createContext<AuthActorContextType>({} as AuthActorContextType)

const actor = startAppMachine({
  machine: authMachine,
  debugger: authMachineCtx.debugger,
})

export function AuthProvider({ children }: React.PropsWithChildren) {
  return (
    <SessionProvider>
      <AuthActorContext.Provider value={{ actor }}>
        <AuthRouter>{children}</AuthRouter>
        <a
          style={{ display: 'none' }}
          data-testid="nextauth-token-send"
          onClick={() => {
            console.error('nextauth-token-send: must be used on CI only')
            const timestamp = new Date().toISOString()
            actor.send({ type: 'NEXTAUTH_TOKEN_UPDATE', data: { token: `${timestamp}@example.com` } })
          }}
        >
          Testing only
        </a>
      </AuthActorContext.Provider>
    </SessionProvider>
  )
}
